import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { AccountService } from '../_services/account.service';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { ActivatedRoute } from '@angular/router';
import { StatusCode } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-policy-activity',
  templateUrl: './policy-activity.component.html',
  styleUrls: ['./policy-activity.component.scss']
})
export class PolicyActivityComponent implements OnInit, OnDestroy {
    //Create HeaderData object to show the Data on Blue Header.
    private headerData:HeaderData;
    private selectedPolicyNumber;
    private selectedAccount;
    private activities = [];
    private loading: boolean = false;
    resultsNotFound = RESULTS_NOT_FOUND;
    private criteria: PageCriteria;
    private hasActivities: boolean = true;
    private hasAccess:boolean = false;

    //private killServicesOnDestroy = [];

    constructor(private route:ActivatedRoute, private accountService: AccountService) { }

    ngOnInit() {
      this.selectedAccount = this.accountService.getAccountData();
      //Getting Policy Number for State params
      this.route.paramMap.subscribe(params => {
        this.selectedPolicyNumber = params.get("pid").toString();
      });
      /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
      /* Setting Headers Ended */

      this.criteria = new PageCriteria();

      this.fetchAccountActivity();
    }
    setHeaderData(){
      this.headerData.pageTitle = "Policy Activity: " + this.selectedPolicyNumber;
      this.headerData.breadcrumb = [{itemName: this.selectedAccount.accountName, itemLink: "accounts/"+this.selectedAccount.accountNumber+"/policies"},
        {itemName: "Direct Bill", itemLink: "accounts/"+this.selectedAccount.accountNumber+"/directbill"}];

      this.accountService.header = this.headerData;
    }

    fetchAccountActivity(){
      this.loading = true;
      this.hasActivities = true;
      let accountSubscription = this.accountService.fetchPolicyActivity(this.selectedPolicyNumber).subscribe((activities:any) => {
        this.loading = false;
        this.hasAccess = true;
        this.activities = activities;
        this.hasActivities = this.activities.length > 0;
      },error=>{
        this.loading = false;
        this.hasActivities = false;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });

      this.accountService.runningServices.push(accountSubscription);
    }
    onPageChange(){
      window.scrollTo(0, 0);
    }
        
    ngOnDestroy() {
      this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
    }

}
